import { overlayStyle } from './config';

class OverlayStyleProvider {
    constructor() {
        this.styles = overlayStyle;
    }

    getStyle(id) {
        return this.styles[id];
    }
}

export default new OverlayStyleProvider();
